import { configureStore } from '@reduxjs/toolkit'
import authReducer from './reducers/authSlice'
import monitoringReducer from './reducers/monitoringSlice'
import clientsReducer from './reducers/clientsSlice'
import socketReducer from './reducers/socketSlice'
import settingsReducer from './reducers/settingsSlice'
import adminUsersReducer from './reducers/adminUsersSlice'
import usersReducer from './reducers/usersSlice'
import organizationsReducer from './reducers/organizationsSlice'
import communicationsReducer from './reducers/communicationsSlice'
import printServerReducer from './reducers/printServerSlice'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    monitoring: monitoringReducer,
    clients: clientsReducer,
    socket: socketReducer,
    settings: settingsReducer,
    adminUsers: adminUsersReducer,
    users: usersReducer,
    organizations: organizationsReducer,
    communications: communicationsReducer,
    printServer: printServerReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore socket instance in actions
        ignoredActions: ['socket/connect', 'socket/disconnect'],
        ignoredPaths: ['socket.instance'],
      },
    }),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch